var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_2528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 250C500 111.929 388.071 0 250 0C111.929 0 0 111.929 0 250C0 388.071 111.929 500 250 500C388.071 500 500 388.071 500 250Z",
    fill: "#3E6365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.506 110.409C323.942 111.131 281.342 138.927 273.579 185.535C310.124 163.584 329.636 194.445 310.93 229.386C292.25 264.295 275.183 287.088 266.254 287.088C257.338 287.088 250.469 263.724 240.253 222.886C229.682 180.665 229.768 104.615 185.852 113.234C144.433 121.361 90 186.36 90 186.36L103 203.411C103 203.411 129.815 182.277 138.751 192.836C147.687 203.401 181.766 330.929 193.152 354.464C203.09 375.103 230.52 402.416 260.579 382.915C290.619 363.427 390.529 278.121 408.407 177.41C416.785 130.208 390.887 109.772 359.506 110.409Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_2528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVimeo);
export default __webpack_public_path__ + "static/media/icon-vimeo.590bcf66129721480972ba4fa5521c00.svg";
export { ForwardRef as ReactComponent };